import { render, staticRenderFns } from "./HistoryStatementsTab.vue?vue&type=template&id=037e493e&scoped=true"
import script from "./HistoryStatementsTab.vue?vue&type=script&lang=js"
export * from "./HistoryStatementsTab.vue?vue&type=script&lang=js"
import style0 from "./HistoryStatementsTab.vue?vue&type=style&index=0&id=037e493e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037e493e",
  null
  
)

export default component.exports